<template>
  <b-row
    v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
    class="content-header"
  >

    <!-- Content Left -->
    <b-col
      class="content-header-left mb-2"
      cols="12"
      md="9"
    >
      <b-row class="breadcrumbs-top">
        <b-col cols="12">
          <h2 class="content-header-title float-left pr-1 mb-0">
            {{ $route.meta.pageTitle }}
          </h2>
          <div class="breadcrumb-wrapper">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <b-link to="/admin">
                  <feather-icon
                    icon="HomeIcon"
                    size="16"
                    class="align-text-top"
                  />
                </b-link>
              </li>
              <li
                v-for="item in $route.meta.breadcrumb"
                :key="item.text"
                class="breadcrumb-item"
                :class="{ active: item.active }"
                :aria-current="item.active ? 'page' : null"
              >
                <b-link
                  v-if="item.to && !item.active"
                  :to="item.to"
                >
                  {{ item.text }}
                </b-link>
                <span v-else>{{ item.text }}</span>
              </li>
            </ol>
          </div>
        </b-col>
      </b-row>
    </b-col>

  </b-row>
</template>

<script>
import {
  BLink, BRow, BCol,
} from 'bootstrap-vue'

export default {
  components: {
    BLink,
    BRow,
    BCol,
  },
}
</script>
